import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { PimDashboardServices } from "data/globalData";

import { useNavigate, useOutletContext } from "react-router-dom";
import Users from "components/Users/Users";
import CreateStyle from "./DashboardComponents/Designer/CreateStyle/CreateStyle";
import BulkUploadStyles from "./DashboardComponents/Designer/BulkUploadStyles/BulkUploadStyles";
import SelectedStyle from "./DashboardComponents/Designer/SelectedStyle/SelectedStyle";
import StylesDashboardShell from "./DashboardComponents/Designer/StylesDashboard/StylesDashboardShell";
import BuyingSheet from "./DashboardComponents/Buying/BuyingSheet/BuyingSheet";
import FabricAndTrims from "./DashboardComponents/Designer/FabricAndTrims/FabricAndTrims";
import ProductionAllocation from "./DashboardComponents/Sourcing/ProductionAllocation/ProductionAllocation";
import MerchantData from "./DashboardComponents/Studio/MerchantData/MerchantData";
import CreateShoot from "./DashboardComponents/Studio/CreateShoot/CreateShoot";
import { attributeCollectionTypes } from "./data";
import DesignerAttributes from "./DashboardComponents/Designer/DesignerAttributes/DesignerAttributes";
import DesignerAttributeGroups from "./DashboardComponents/Designer/DesignerAttributeGroups/DesignerAttributeGroups";
import StudioAttributeGroups from "./DashboardComponents/Studio/StudioAttributeGroups/StudioAttributeGroups";
import StudioAttributes from "./DashboardComponents/Studio/StudioAttributes/StudioAttributes";
import ModalProfileDashboard from "./DashboardComponents/Studio/ModalProfileDashboard/ModalProfileDashboard";
import CreateModalProfile from "./DashboardComponents/Studio/CreateModalProfile/CreateModalProfile";
import ShootsDashboard from "./DashboardComponents/Studio/ShootsDashboard/ShootsDashboard";
import SelectedModalProfile from "./DashboardComponents/Studio/SelectedModalProfile/SelectedModalProfile";
import SelectedBuying from "./DashboardComponents/Buying/SelectedBuying/SelectedBuying";
import SelectedShoot from "./DashboardComponents/Studio/SelectedShoot/SelectedShoot";
import CreateOpenCosting from "./DashboardComponents/Sourcing/CreateOpenCosting/CreateOpenCosting";
import OpenCostingDashboard from "./DashboardComponents/Sourcing/OpenCostingDashboard/OpenCostingDashboard";
import SelectedOpenCosting from "./DashboardComponents/Sourcing/SelectedOpenCosting/SelectedOpenCosting";
import StudioSampleInward from "./DashboardComponents/Studio/StudioSampleInward/StudioSampleInward";
import CreateShootCosting from "./DashboardComponents/Studio/CreateShootCosting/CreateShootCosting";
import ShootCostingDashboard from "./DashboardComponents/Studio/ShootCostingDashboard/ShootCostingDashboard";
import SelectedShootCosting from "./DashboardComponents/Studio/SelectedShootCosting/SelectedShootCosting";
import FabricMaster from "./DashboardComponents/Sourcing/FabricMaster/FabricMaster";
import TrimsMaster from "./DashboardComponents/Sourcing/TrimsMaster/TrimsMaster";
import TrimsERP from "./DashboardComponents/Sourcing/TrimsERP/TrimsERP";
import FootwearMaterialMaster from "./DashboardComponents/Sourcing/FootwearMaterialMaster/FootwearMaterialMaster";
import FabricStylesDashboard from "./DashboardComponents/Sourcing/FabricStylesDashboard/FabricStylesDashboard";
import StyleBlockMaster from "./DashboardComponents/Catalogue/StyleBlockMaster/StyleBlockMaster";
import ShootSummary from "./DashboardComponents/Studio/ShootSummary/ShootSummary";
import ShootArchive from "./DashboardComponents/Studio/ShootArchive/ShootArchive";
import MrpSheetShell from "./DashboardComponents/Buying/MrpSheet/MrpSheetShell";
import FOBPurchaseOrder from "./DashboardComponents/Sourcing/FOBPurchaseOrder/FOBPurchaseOrder";
import FabricTrimsNew from "./DashboardComponents/Designer/FabricAndTrims/FabricAndTrimsNew.js";
import BuyQtySheetShell from "./DashboardComponents/Buying/BuyQtySheet/BuyQtySheetShell.js";

const PimDashboard = () => {
	const [currentPath, service] = useOutletContext();
	console.log(currentPath, "currentPath");
	const navigate = useNavigate();

	const tabComponents = {
		[PimDashboardServices.designer.types.attribute_master.types.attributes.key]: {
			...PimDashboardServices.designer.types.attribute_master.types.attributes,
			component: <DesignerAttributes collection={attributeCollectionTypes.STYLES} />,
		},
		[PimDashboardServices.designer.types.attribute_master.types.attribute_groups.key]: {
			...PimDashboardServices.designer.types.attribute_master.types.attribute_groups,
			component: <DesignerAttributeGroups collection={attributeCollectionTypes.STYLES} />,
		},
		[PimDashboardServices.studio.types.shoot_master.types.shoot_attributes.key]: {
			...PimDashboardServices.studio.types.shoot_master.types.shoot_attributes,
			component: <StudioAttributes collection={attributeCollectionTypes.SHOOTS} />,
		},
		[PimDashboardServices.studio.types.shoot_master.types.shoot_attr_groups.key]: {
			...PimDashboardServices.studio.types.shoot_master.types.shoot_attr_groups,
			component: <StudioAttributeGroups collection={attributeCollectionTypes.SHOOTS} />,
		},
		[PimDashboardServices.studio.types.modal_profiles.types.modal_profile_master.types.modal_attributes.key]: {
			...PimDashboardServices.studio.types.modal_profiles.types.modal_profile_master.types.modal_attributes,
			component: <StudioAttributes collection={attributeCollectionTypes.MODAL_PROFILES} />,
		},
		[PimDashboardServices.studio.types.modal_profiles.types.modal_profile_master.types.modal_attr_groups.key]: {
			...PimDashboardServices.studio.types.modal_profiles.types.modal_profile_master.types.modal_attr_groups,
			component: <StudioAttributeGroups collection={attributeCollectionTypes.MODAL_PROFILES} />,
		},
		[PimDashboardServices.studio.types.modal_profiles.types.all_modal_profiles.key]: {
			...PimDashboardServices.studio.types.modal_profiles.types.all_modal_profiles,
			component: <ModalProfileDashboard />,
		},
		[PimDashboardServices.studio.types.summary.key]: {
			...PimDashboardServices.studio.types.summary.key,
			component: <ShootSummary />,
		},
		[PimDashboardServices.studio.types.all_shoots.key]: {
			...PimDashboardServices.studio.types.all_shoots.key,
			component: <ShootsDashboard />,
		},
		[PimDashboardServices.studio.types.shoot_archive.key]: {
			...PimDashboardServices.studio.types.shoot_archive,
			component: <ShootArchive />,
		},
		[PimDashboardServices.designer.types.create_style.key]: {
			...PimDashboardServices.designer.types.create_style,
			component: <CreateStyle />,
		},
		[PimDashboardServices.designer.types.bulk_upload_styles.key]: {
			...PimDashboardServices.designer.types.bulk_upload_styles,
			component: <BulkUploadStyles />,
		},
		[PimDashboardServices.designer.types.selected_style.key]: {
			...PimDashboardServices.designer.types.selected_style,
			component: <SelectedStyle />,
		},
		[PimDashboardServices.designer.types.styles.key]: {
			...PimDashboardServices.designer.types.styles,
			component: <StylesDashboardShell />,
		},
		[PimDashboardServices.sourcing.types.fabric_styles.key]: {
			...PimDashboardServices.sourcing.types.fabric_styles,
			component: <FabricStylesDashboard />,
		},
		// [PimDashboardServices.designer.types.designer_users.key]: {
		// 	...PimDashboardServices.designer.types.designer_users,
		// 	component: <DesignerUsers />,
		// },
		[PimDashboardServices.designer.types.fabric_trims_sheet.key]: {
			...PimDashboardServices.designer.types.fabric_trims_sheet,
			// component: <FabricTrimsNew />,
			component: <FabricAndTrims />,
		},
		[PimDashboardServices.buying.types.mrp_sheet.key]: {
			...PimDashboardServices.buying.types.mrp_sheet,
			component: <MrpSheetShell />,
			// component: <BuyingPage />,
		},
		[PimDashboardServices.buying.types.buy_qty_sheet.key]: {
			...PimDashboardServices.buying.types.buy_qty_sheet,
			component: <BuyQtySheetShell />,
			// component: <BuyingPage />,
		},
		[PimDashboardServices.buying.types.buying_sheet.key]: {
			...PimDashboardServices.buying.types.buying_sheet,
			component: <BuyingSheet />,
			// component: <BuyingPage />,
		},
		[PimDashboardServices.buying.types.selected_buying.key]: {
			...PimDashboardServices.buying.types.selected_buying,
			component: <SelectedBuying />,
			// component: <BuyingPage />,
		},
		[PimDashboardServices.sourcing.types.production_allocation.key]: {
			...PimDashboardServices.sourcing.types.production_allocation,
			component: <ProductionAllocation />,
		},
		[PimDashboardServices.sourcing.types.fabric_master.key]: {
			...PimDashboardServices.sourcing.types.fabric_master,
			component: <FabricMaster />,
		},
		[PimDashboardServices.sourcing.types.trims_master.key]: {
			...PimDashboardServices.sourcing.types.trims_master,
			component: <TrimsMaster />,
		},
		[PimDashboardServices.sourcing.types.trims_erp.key]: {
			...PimDashboardServices.sourcing.types.trims_erp,
			component: <TrimsERP />,
		},
		[PimDashboardServices.sourcing.types.footwear_material_master.key]: {
			...PimDashboardServices.sourcing.types.footwear_material_master,
			component: <FootwearMaterialMaster />,
		},
		[PimDashboardServices.catalogue.types.style_block_master.key]: {
			...PimDashboardServices.catalogue.types.style_block_master,
			component: <StyleBlockMaster />,
		},
		[PimDashboardServices.sourcing.types.open_costing.types.create_open_costing.key]: {
			...PimDashboardServices.sourcing.types.open_costing.types.create_open_costing,
			component: <CreateOpenCosting />,
		},
		[PimDashboardServices.sourcing.types.open_costing.types.selected_open_costing.key]: {
			...PimDashboardServices.sourcing.types.open_costing.types.selected_open_costing,
			component: <SelectedOpenCosting />,
		},
		[PimDashboardServices.sourcing.types.open_costing.types.open_costing_dashboard.key]: {
			...PimDashboardServices.sourcing.types.open_costing.types.open_costing_dashboard,
			component: <OpenCostingDashboard />,
		},
		[PimDashboardServices.users.key]: {
			...PimDashboardServices.users,
			component: <Users />,
		},
		[PimDashboardServices.sourcing.types.fob_po.key]: {
			...PimDashboardServices.sourcing.types.fob_po,
			component: <FOBPurchaseOrder />,
		},
		[PimDashboardServices.sourcing.types.merchant_data.key]: {
			...PimDashboardServices.sourcing.types.merchant_data,
			component: <MerchantData />,
		},
		[PimDashboardServices.studio.types.sample_inward.key]: {
			...PimDashboardServices.studio.types.sample_inward,
			component: <StudioSampleInward />,
		},
		[PimDashboardServices.studio.types.create_shoot.key]: {
			...PimDashboardServices.studio.types.create_shoot,
			component: <CreateShoot />,
		},
		[PimDashboardServices.studio.types.selected_shoot.key]: {
			...PimDashboardServices.studio.types.selected_shoot,
			component: <SelectedShoot />,
		},
		[PimDashboardServices.studio.types.shoot_costing.types.create_shoot_costing.key]: {
			...PimDashboardServices.studio.types.shoot_costing.types.create_shoot_costing.key,
			component: <CreateShootCosting />,
		},
		[PimDashboardServices.studio.types.shoot_costing.types.selected_shoot_costing.key]: {
			...PimDashboardServices.studio.types.shoot_costing.types.selected_shoot_costing.key,
			component: <SelectedShootCosting />,
		},
		[PimDashboardServices.studio.types.shoot_costing.types.all_shoot_costings.key]: {
			...PimDashboardServices.studio.types.shoot_costing.types.all_shoot_costings.key,
			component: <ShootCostingDashboard />,
		},
		[PimDashboardServices.studio.types.modal_profiles.types.create_modal_profile.key]: {
			...PimDashboardServices.studio.types.modal_profiles.types.create_modal_profile,
			component: <CreateModalProfile />,
		},
		[PimDashboardServices.studio.types.modal_profiles.types.selected_modal_profile.key]: {
			...PimDashboardServices.studio.types.modal_profiles.types.selected_modal_profile,
			component: <SelectedModalProfile />,
		},
	};

	return (
		<Box sx={{ width: "100%", p: 1, boxSizing: "border-box" }}>
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRoundedIcon />
				</IconButton>
				<Typography variant="h5">{service?.name}</Typography>
			</Box>
			{/* {tabComponents &&
					tabComponents
						.filter((row) => row.key === currentPath)
						.map((row) => {
							console.log(row, "rowwww");
							return (
								<Box
									width="98%"
									margin="auto"
									key={row.key}
									// display={row.key === currentPath ? "block" : "none"}
								>
									{row.component}
								</Box>
							);
						})} */}
			{tabComponents?.[currentPath]?.component}
		</Box>
	);
};

export default PimDashboard;
